import React, { useState, useEffect } from 'react';
import { Download, Search, CheckCircle, FileText } from 'lucide-react';

interface SentQuotation {
    id: number;
    name: string;
    email: string;
    serviceType: string;
    sentDate: string;
    totalAmount: number;
    pdfPath: string; // for downloading
}

const QuotationHistory: React.FC = () => {
    const [history, setHistory] = useState<SentQuotation[]>([]);

    useEffect(() => {
        // Fetch Sent Quotations
        fetch('https://www.projectinfotech.in/api/quotation/history')
        // fetch('http://localhost:2025/api/quotation/history')
            .then(res => res.json())
            .then(data => setHistory(data))
            .catch(err => console.error(err));
    }, []);

    const handleDownload = (id: number) => {
        window.open(`https://www.projectinfotech.in/api/quotation/download/${id}`, '_blank');
        // window.open(`http://localhost:2025/api/quotation/download/${id}`, '_blank');
    };

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <h1 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                <FileText className="text-red-600"/> Quotation History
            </h1>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <table className="w-full text-left">
                    <thead className="bg-gray-100 border-b">
                        <tr>
                            <th className="p-4 font-bold text-gray-600">Client Name</th>
                            <th className="p-4 font-bold text-gray-600">Service</th>
                            <th className="p-4 font-bold text-gray-600">Sent Date</th>
                            <th className="p-4 font-bold text-gray-600">Amount</th>
                            <th className="p-4 font-bold text-gray-600 text-right">PDF</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {history.map((q) => (
                            <tr key={q.id} className="hover:bg-gray-50">
                                <td className="p-4">
                                    <div className="font-bold">{q.name}</div>
                                    <div className="text-xs text-gray-500">{q.email}</div>
                                </td>
                                <td className="p-4 text-sm">{q.serviceType}</td>
                                <td className="p-4 text-sm">{new Date(q.sentDate).toLocaleDateString()}</td>
                                <td className="p-4 font-bold text-green-600">₹ {q.totalAmount?.toLocaleString()}</td>
                                <td className="p-4 text-right">
                                    <button 
                                        onClick={() => handleDownload(q.id)}
                                        className="inline-flex items-center gap-2 bg-gray-100 text-gray-700 px-3 py-1 rounded hover:bg-gray-200 text-sm font-medium"
                                    >
                                        <Download size={14}/> Download
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {history.length === 0 && (
                            <tr><td colSpan={5} className="p-8 text-center text-gray-400">No sent quotations yet.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default QuotationHistory;